<template>
	<draggable
		:list="modelValue"
		v-bind="$props"
		:group="groupName"
		item-key="id"
		@change="$emit('change', modelValue)"
	>
		<template v-slot:item="{ element }">
			<div :class="customClass"
				class="d-flex align-center">
				<ao-icon iconColor="textSecondary"
					iconName="dragNDrop"/>
				<div v-if="!type"
					class="ao-drag-n-drop-list-item">
					{{ element[itemTitle] }}
				</div>
				<component
					:is="`ao-${type}`"
					v-else
					v-model="element.selected"
					class="w-100 ao-drag-n-drop-list-item"
				>
					{{ element[itemTitle] }}
				</component>
			</div>
		</template>
	</draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    name: 'AoDragNDropList',

    components: { draggable },

    props: {
        custom: {type: String, default: null},

        modelValue: { type: Array, default: () => [] },

        group: { type: String, default: '' },

        type: { type: String, default: 'checkbox' },

        itemTitle: { type: String, default: 'name' },
    },

    computed: {
        groupName() {
            return this.group || 'key-' + Math.random()
        },
        customClass() {
			let prefix = 'ao-drag-n-drop-list-'
			let customClass = ''
			if (this.custom) {
				customClass = prefix + this.custom
			}
			return customClass
		},
    }
}
</script>

<style lang="scss">

.ao-drag-n-drop-list-custom-hover{
    margin-bottom: 10px;

    .ao-drag-n-drop-list-item{
        padding:6px;
        border-radius: 4px;
        &:hover{
        background-color:#ECF1F7;
        box-shadow: 0px 3px 5px rgba(34, 40, 43, 0.2);
        cursor:pointer;
        }
    }
    // &:last-child {
    //     margin-bottom: 0px;  
    // }
}
</style>
